import React, { Component } from "react";
import Helper from "../../utilities/Helper";
import { withIntl } from "../../../common/lang";

class PreviousLungTransplant extends Component {
  componentDidUpdate = (prv) => {
    if (prv.previousLungTransplant !== this.props.previousLungTransplant) {
      this.props.setSelected(
        "previousLungTransplant",
        this.checkPreviousLungTransplant(this.props.previousLungTransplant)
      );
    }
  };

  handlePreviousLungTransplantInputChange = (event) => {
    this.props.handleOnChange(event);
  };

  previousLungTransplantHelper = () => {
    const { formatMessage } = this.props.intl;
    if (this.checkPreviousLungTransplant(this.props.previousLungTransplant)) {
      return (
        <Helper
          text={formatMessage({ id: "form.previousLungTransplant.helper" })}
        />
      );
    }
  };

  checkPreviousLungTransplant = (previousLungTransplant) => {
    if (previousLungTransplant === "yes") {
      return true;
    } else {
      return false;
    }
  };

  render() {
    const { formatMessage } = this.props.intl;
    return (
      <div className="col-12 element-group">
        <div className="row">
          <div className="col-12">
            <div className="search-label">
              {formatMessage({ id: "form.previousLungTransplant" })}
            </div>
          </div>
          <div className="col-12">
            <select
              className="form-control search-select search-select-md"
              name="previousLungTransplant"
              onChange={this.handlePreviousLungTransplantInputChange}
              value={this.props.previousLungTransplant}
            >
              <option value="">
                {formatMessage({ id: "ui.label.select" })}
              </option>
              <option value="yes">{formatMessage({ id: "form.yes" })}</option>
              <option value="no">{formatMessage({ id: "form.no" })}</option>
            </select>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="helper-text">
              {this.previousLungTransplantHelper()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withIntl(PreviousLungTransplant);
